export default __webpack_public_path__ + "static/media/flag-14.bfce93cb.gif";